import React, { useEffect, useState } from 'react';
import { getErrorMessage } from '@utils/commons';
import { useErrors } from '@contexts/ErrorsContext';

interface FullNameProps {
  fullName: string;
  setFullName: (fullName: string) => void;
}

const FullName: React.FC<FullNameProps> = ({ fullName, setFullName }) => {
  const [fullNameErrorMessage, setFullNameErrorMessage] = useState<
    string | undefined
  >('');
  const { errors } = useErrors();

  useEffect(() => {
    setFullNameErrorMessage(getErrorMessage(errors, 'fullName'));
  }, [errors]);

  return (
    <div
      className={`govuk-form-group mt-5 govuk-bp:mt-6 ${fullNameErrorMessage ? 'govuk-form-group--error' : ''}`}
    >
      <h1 className="govuk-label-wrapper">
        <label className="govuk-label govuk-label--l" htmlFor="fullName">
          Full name (required)
        </label>
      </h1>
      {fullNameErrorMessage && (
        <p id="full-name-input-error" className="govuk-error-message">
          <span className="govuk-visually-hidden">Error:</span>
          {fullNameErrorMessage}
        </p>
      )}
      <input
        className={`govuk-input govuk-input--width-20 ${fullNameErrorMessage ? 'govuk-input--error' : ''}`}
        id="fullName"
        name="name"
        type="text"
        aria-describedby={
          fullNameErrorMessage ? 'full-name-input-error' : undefined
        }
        autoComplete="name"
        value={fullName}
        onChange={e => setFullName(e.target.value)}
      />
    </div>
  );
};

export default FullName;
